// Super Admins and Store owners can use everything their role reaches. A Sub Admin gets only the areas the Super
// Admin switched on for them, and Staff only the areas their store owner ticked
// ('content', 'orders', 'customers', 'settings').
export const can = (user, permission) => !["subadmin", "staff"].includes(user.role) || (user.permissions || []).includes(permission);
